export const CAMERAS_GENERAL = [
  {
    name: 'Share 303S Pro V2',
    specs: {
      focalLengths: [40, 56],
      sensorSize: { width: 36, height: 24 },
    },
  },
  {
    name: 'Sony α7CR 24㎜',
    specs: {
      focalLengths: [24],
      sensorSize: { width: 35.7, height: 23.8 },
    },
  },
  {
    name: 'Sony ILX-LR1',
    specs: {
      focalLengths: [24, 35],
      sensorSize: { width: 35.7, height: 23.8 },
    },
  },
  {
    name: 'Sony RX0 II',
    specs: {
      focalLengths: [24],
      sensorSize: { width: 13.2, height: 8.8 },
    },
  },
  {
    name: 'UniPod MT11',
    specs: {
      focalLengths: [24],
      sensorSize: { width: 6.4, height: 4.8 },
    },
  },
];
